import request from '@/utils/request'

// 获取短链接
export const getShortUrl = (url = '') => {
  return request.post(
    {
      url: '/api/s/generateShortUrl',
      data: {
        url,
        time: Date.now(),
      },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}
// 解析短链接
export const analysisShortUrl = (hashcode) => {
  return request.get({
    url: `/api/s/${hashcode}`,
  })
}
